import { useCallback } from 'react';
import useTutorialTrigger from './useTutorialTrigger';
import { TUTORIAL_FEATURES } from '../config/tutorials.config';

const useFilterTutorial = () => {
  const { triggerTutorial, trackFeatureUsage } = useTutorialTrigger();

  return useCallback(async () => {
    // Track feature usage for analytics
    trackFeatureUsage(TUTORIAL_FEATURES.FILTER_SELECTION).catch((error) => {
      console.error('Failed to track filter selection usage:', error);
    });

    // Trigger tutorial - the tutorial system will handle:
    // - Whether to show prompt or tiny bar (based on session state)
    // - Whether user has already seen/disabled this tutorial
    // - Preventing duplicates (already handled by TutorialContext)
    try {
      await triggerTutorial(TUTORIAL_FEATURES.FILTER_SELECTION);
    } catch (error) {
      console.error('Failed to trigger filter selection tutorial:', error);
    }
  }, [trackFeatureUsage, triggerTutorial]);
};

export default useFilterTutorial;

